module.exports = __webpack_public_path__ + "img/avatar-default.e61b5e0c.png";